var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiper-container" },
    [
      _vm._t("parallax-bg"),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.defaultSwiperClasses.wrapperClass },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm._t("pagination"),
      _vm._v(" "),
      _vm._t("button-prev"),
      _vm._v(" "),
      _vm._t("button-next"),
      _vm._v(" "),
      _vm._t("scrollbar")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee2374dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee2374dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome-swiper/src/swiper.vue
// module id = null
// module chunks = 